import {
  PROVINCES_FETCHING,
  FETCH_PROVINCES,
  FILTER_PROVINCES_BY_PATTERN,
  FIND_PROVINCE,
} from "../actions/types";

const initialState = {
  items: [],
  loadedItems: [],
  filteredItems: [],
  found: null,
  isFetching: false,
  limit: 0,
  offset: 0,
  loader: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case PROVINCES_FETCHING:
      return { ...state, isFetching: true };

    case FETCH_PROVINCES:
      return {
        ...state,
        items: action.payload.items,
        filteredItems: action.payload.loaded,
        loader: action.payload.loader,
        isFetching: false,
      };

    case FIND_PROVINCE:
      return {
        ...state,
        items: [...state.items, action.payload],
      };

    default:
      return state;
  }
}
